import { makeAutoObservable } from "mobx";
import { SearchPromotionProgram } from "app/common/Model/SearchObject";
import { deletePromotionProgram, getPromotionProgramById, searchByPagePromotionProgram, saveOrUpdatePromotionProgram } from "app/services/ServicePromotionProgram";
import { toast } from "react-toastify";
import { PromotionProgramType } from "app/common/Model/PromotionProgram";
//import { downloadPromotionProgram, importExcelPromotionProgram } from "app/services/ImportExcelService";
//import moment from "moment";

export default class PromotionProgramStore {
    openPromotionProgramCreateOrUpdate = false;
    searchPromotionProgram = new SearchPromotionProgram();
    pagePromotionProgram = null;
    selectedPromotionProgram = new PromotionProgramType();
    openConfirmDeletePromotionProgram = false;
    constructor() {
        makeAutoObservable(this);
    }

    pagingPromotionProgram = async () => {
        //console.log("Dữ liệu gửi đi:", this.searchPromotionProgram);
        return await searchByPagePromotionProgram(this.searchPromotionProgram)
            .then(({ data }) => {
                //console.log("Dữ liệu gửi đi:", data);
                this.pagePromotionProgram = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu PromotionProgram có lỗi");
            });
    };

    handleOpenFormCreateOrEdit = (promotionProgramId) => {
        if (promotionProgramId) {
            getPromotionProgramById(promotionProgramId)
                .then(({ data }) => {
                    this.selectedPromotionProgram = data;
                    this.openPromotionProgramCreateOrUpdate = true;
                })
                .catch((error) => {
                    toast.error("Lấy dữ liệu PromotionProgram có lỗi");
                    console.error("Lỗi lấy dữ liệu PromotionProgram:", error);
                });
        } else {
            this.selectedPromotionProgram = new PromotionProgramType();
            this.openPromotionProgramCreateOrUpdate = true;
        }
    };

    handleCreateOrEdit = async (vatData) => {
        try {
            //console.log("Dữ liệu gửi đi:", vatData);
            const { data } = await saveOrUpdatePromotionProgram(vatData);
            toast.success("Lưu PromotionProgram thành công!");
            this.handleClosePopup();
            await this.pagingPromotionProgram();
            return data;
        } catch (error) {
            toast.error("Lưu PromotionProgram thất bại!");
            console.error("Lưu PromotionProgram thất bại!:", error);
        }
    };

    handleDelete = async () => {
        const promotionProgramId = this.selectedPromotionProgram?.id;
        if (!promotionProgramId) return;

        deletePromotionProgram(promotionProgramId)
            .then(() => {
                // Nếu đang ở trang > 1 và chỉ còn 1 dòng dữ liệu, thì lùi về trang trước
                if (
                    this.searchPromotionProgram?.pageIndex > 1 &&
                    this.pagePromotionProgram?.content?.length === 1
                ) {
                    this.searchPromotionProgram.pageIndex -= 1;
                }
                toast.success("Xóa PromotionProgram thành công!");
                this.pagingPromotionProgram();
                this.handleClosePopup();
            })
            .catch((error) => {
                console.error("Lỗi khi xóa PromotionProgram:", error);
                toast.error("Xóa PromotionProgram thất bại!");
            });
    };

    handleChangeFormSearch = (searchPromotionProgram) => {
        this.searchPromotionProgram = {
            ...this.searchPromotionProgram,
            ...searchPromotionProgram,
        };
        this.pagingPromotionProgram();
    };

    handleDeletePromotionProgram = (promotionProgram) => {
        this.selectedPromotionProgram = promotionProgram;
        this.openConfirmDeletePromotionProgram = true;
    };

    handleClosePopup = () => {
        this.openPromotionProgramCreateOrUpdate = false;
        this.openConfirmDeletePromotionProgram = false;
    };
    // handleDownloadPromotionProgram = async () => {
    //     try {
    //         const res = await downloadPromotionProgram();
    //         const url = window.URL.createObjectURL(res?.data);
    //         const link = document.createElement("a");
    //         link.href = url;
    //         link.setAttribute(
    //             "download",
    //             "MAU_NHAP_PromotionProgram" + moment(new Date()).format("DDMMYYYY-HHmm") + ".xlsx"
    //         );
    //         document.body.appendChild(link);
    //         link.click();
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    // handleImportExcelPromotionProgram = (file) => {
    //     importExcelPromotionProgram(file)
    //         .then(({ data }) => {
    //             toast.success("Tải file thành công!");
    //             // this.handleClosePopup();
    //             this.pagingPromotionProgram();
    //         })
    //         .catch((error) => {
    //             console.error(error);
    //             toast.error("Lấy dữ liệu có lỗi");
    //         });
    // };

    resetStore = () => {
        this.searchPromotionProgram = new SearchPromotionProgram();
        this.pagePromotionProgram = null;
        this.selectedPromotionProgram = new PromotionProgramType();
        this.openPromotionProgramCreateOrUpdate = false;
    };
}
